import React from 'react'
import { useUpgradable } from 'hooks/upgradable'
import UpgradeCTA from 'components/upgrade-cta'

export default ({ salt }) => {
    const customSurveysUpgradable = useUpgradable()({ feature: 'surveys-custom' })
    if(!customSurveysUpgradable) {
        return null
    }

    return (
        <UpgradeCTA
            useUpgradeIcon
            feature="surveys-custom"
            useFeatureTitle
            useFeatureDescription
            useFeatureOrModuleIcon
            className="airy"
            salt={salt} />
    )
}